export class EstadoInfoChvI{
	id : BigInteger;
  anio : Number;
  periodo : String;
  idperiodo : any;
  fuente : any;
  estado : String;
  novedadSis : String;
  novedadUsu : String;
  fecha : String;
  observacionFte : String;
  observacionSis : String;
  estadocargue : String;
  numeroErrores : any;
}
